(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('corporation', {
                parent: 'entity',
                url: '/corporation',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'Corporations'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/corporation/list/corporation.html',
                        controller: 'CorporationController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
